import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames as fetchTableColumnNames, 
  getLogs,
} from "../../helpers/fakebackend_helper";



// Fetch Logs Table Column Names
export const fetchLogsTableColumnNames = createAsyncThunk(
  "logs/fetchTableColumnNames",
  async (logs, thunkAPI) => {
    try {
      const response = await fetchTableColumnNames(logs); // Ensure the correct function is called
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Logs data
export const fetchLogs = createAsyncThunk("logs/fetch", async (logs, thunkAPI) => {
  try {
    const response = await getLogs(logs);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});
